<template>
  <div>
    <QueryFrame
      @handlePage="handlePage"
      @handlePageSize="handlePageSize"

      :current="page"
      :count="count">
      <div slot="queryParams" class="queryContainer">
        <div class="queryItem" v-if="roleType!==2">
          <label>门店名称:</label>
          <storeListSelect class="item" v-model="query.storeIdList"></storeListSelect>
        </div>
        <div class="queryItem">
          <label>库存日期:</label>
          <timeStampDatePicker class="item" v-model="query.queryDate" :options="disableFromNow"  clearable></timeStampDatePicker>
        </div>
        <div class="queryItem">
          <label>商品仓库:</label>
          <lk-select class="item" v-model="query.warehouseIds" clearable>
            <lk-option v-for="item in warehouseList" :value="item.id" :key="item.id">
              {{ item.name }}
            </lk-option>
          </lk-select>
        </div>
        <div class="queryItem">
            <goodsSearchItem v-model="query.nameMix"></goodsSearchItem>

          <!-- <label>商品搜索:</label>
          <lk-input class="item" v-model.trim="query.keyword" :maxlength="100" clearable placeholder="商品名称、商品编码、助记码、通用名称"></lk-input> -->
        </div>
        <div class="queryItem">
          <label>商品类型:</label>
          <lk-select class="item" v-model="query.type" clearable>
            <lk-option v-for="(item, index) in getNormalGoodsTypes" :key="index" :value="item.value">{{item.name}}</lk-option>
          </lk-select>
        </div>
        <div class="queryItem storeSelect">
          <label>供应商:</label>
          <SupplierListSelect multiple v-model="query.supplierIds"></SupplierListSelect>
        </div>
        <div class="queryItem">
            <label>来源:</label>
            <lk-select v-model='query.purchaseType' class="item" clearable  >
              <lk-option v-for='(item ,i) in getGoodsOrigin' :key="i" :value='item.value'>{{item.name}}</lk-option>
            </lk-select>
          </div>
        <div class="queryItem">
          <lk-button class="mr" type="primary" @click="handleSearch">查询</lk-button>
          <lk-button @click="handleReset">重置</lk-button>
        </div>
      </div>
      <div slot="table">
        <DownloadButton class="mb8" @on-click="getDownload" v-if="handlePermission('allStockCountExcel')"></DownloadButton>
        <lk-table border :columns="columns" :data="tableData"></lk-table>
      </div>
    </QueryFrame>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import QueryFrame from '../../components/frame/QueryFrame.vue';
import inventory from '../../services/inventory';
import utils from '../../libs/utils';
import mapState from '../../mixins/mapState'; // 鉴权
import queryMixins from '../../mixins/queryMixins';
import SupplierListSelect from '../../components/SupplierListSelect.vue';
import DownloadButton from '../../components/download/DownloadButton.vue';

export default {
  name: 'stockAllCount',
  mixins: [mapState, queryMixins],
  components: {
    QueryFrame,
    SupplierListSelect,
    DownloadButton,
  },
  computed: {
    ...mapGetters(['getNormalGoodsTypes', 'getGoodsOrigin']),
    goodsTypes() {
      return this.$store.state.publicParams.goodsTypes;
    },
    hasDetail() {
      return this.handlePermission('stockAllCountDetail');
    },
  },
  data() {
    return {
      warehouseList: [],
      query: {
        storeIdList: null,
        warehouseIds: [],
        nameMix: '',
        goodsType: null,
        supplierIds: null,
        queryDate: null,
      },
      disableFromNow: {
        disabledDate(date) {
          return date && date.valueOf() > Date.now();
        },
      },
      columns: [
        {
          title: '商品编码',
          key: 'serialCode',
	        minWidth: 116,
        },
        {
          title: '商品通用名称',
          key: 'approvedName',
	        minWidth: 116,
        },
        {
          title: '规格',
          key: 'spec',
	        minWidth: 116,
        },
        {
          title: '储存条件',
          key: 'storageCondition',
          minWidth: 116,
        },
        {
          title: '生产厂家',
          key: 'producer',
	        minWidth: 116,
        },
        {
          title: '上市许可持有人',
          minWidth: 120,
          tooltip: true,
          key: 'mah',
        },
        {
          title: '批准文号/注册证号',
          key: 'approvalCode',
          minWidth: 176,
          tooltip: true,
        },
        {
          title: '总数量',
          key: 'totalNum',
          minWidth: 116,
        },
        {
          title: '单位',
          key: 'minPkgUnitName',
          minWidth: 116,
        },
	      {
		      title: '含税成本',
		      key: 'costWithTaxStr',
		      minWidth: 116,
	      },
	      {
		      title: '不含税成本',
		      key: 'costWithOutTaxStr',
		      minWidth: 116,
	      },
	      {
		      title: '库存结算方式',
		      key: 'invoicingCondition',
		      minWidth: 116,
	      },
        {
		      title: '按月库存天数（DOS）',
		      key: 'monthDos',
		      width: 156,
	      },
        {
		      title: '按季度库存天数（DOS）',
		      key: 'quarterDos',
		      width: 170,
	      },
	      {
		      title: '供应商名称',
		      key: 'supplierName',
		      minWidth: 116,
	      },
        {
          title: '操作',
          key: 'operation',
          minWidth: 116,
          fixed: 'right',
          render: (h, { row }) => (this.hasDetail ? h('lk-button', {
            props: {
              type: 'text',
            },
            on: {
              click: () => {
                // const ids = row.inventoryRecordIdList.join(',');
                const params = {
                  queryDate: this.params.queryDate || new Date().getTime(),
                  inventoryIdListStr: row.inventoryIdListStr,
                  goodsStoreId: row.goodsStoreId,
                  storeId: row.storeId,
                  supplierStoreId: row.supplierStoreId,
                  minPkgUnitName: row.minPkgUnitName,
                  purchaseType: row.purchaseType,
                };
                this.$router.push({
                  name: 'stockAllCountDetail',
                  params: { ids: encodeURI(JSON.stringify(params)) },
                });
              },
            },
          }, '详情') : null),
        },
      ],
      tableData: [],
    };
  },
  methods: {
    getWarehouseList() {
      inventory.inventoryNameList().then((res) => {
        if (res.status === 200) {
          this.warehouseList = res.data.data;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    getData(isTransform) {
      this.params.size = this.size;
      this.params.page = this.page;
	    // if (!isTransform && this.params.queryDate) {
		  //   this.params.queryDate = this.params.queryDate.getTime();
	    // }
      inventory.getReportAllCountData(this.params).then((res) => {
        if (res.data.status === 200) {
        	const { count, list } = res.data.data;
          this.count = count;
	        this.tableData = list;
        } else {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
    handleReset() {
    	this.query = {};
    },
    getDownload() {
      const params = Object.assign({}, this.query);
      params.page = 0;
      params.size = 0;
      params.queryCondition = utils.getQueryCondition('.queryContainer');
      // params.queryDate = utils.exchangeDate(params.queryDate);
      inventory.getReportAllCountDataExcel(params).then((res) => {
        if (res.data.error) {
          this.$Message.error(res.data.error);
        }
      }).catch((err) => {
        utils.handleError(err);
      });
    },
  },
  created() {
    this.getWarehouseList();
    this.handleSearch(true);
    if (this.roleType !== 2) {
      this.columns.splice(1, 0, { title: '门店名称', key: 'storeName', minWidth: 116 });
    }

    // 没有权限时，移除操作列
    if (!this.hasDetail) {
      this.columns.pop();
    }
  },
};
</script>

<style lang="less" scoped>
</style>
